import { render, staticRenderFns } from "./ApplicationFormTenancy.vue?vue&type=template&id=570cbcd9&scoped=true"
import script from "./ApplicationFormTenancy.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormTenancy.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormTenancy.vue?vue&type=style&index=0&id=570cbcd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570cbcd9",
  null
  
)

export default component.exports